import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchLastThreeIndustries,
  fetchCurrentIndustries,
  fetchYearlyIndustries,
  fetchCurrentMetrics,
  fetchYearlyMetrics,
  fetchLastThreeMetrics,
} from "../../../../store/metricsSlice";
import { Doughnut } from "react-chartjs-2";
import { Dialog } from "@headlessui/react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

const chartOptions = {
  cutout: "70%",
  plugins: {
    legend: { display: false },
    tooltip: {
      callbacks: {
        label: function (tooltipItem) {
          return `${tooltipItem.label}: $${tooltipItem.raw.toLocaleString()}`;
        },
      },
    },
  },
};

const colors = [
  "#3B80FF",
  "#EC4799",
  "#12BAA3",
  "#F4A51E",
  "#5F65FF",
  "#F7DD33",
];

const industryData = [
  { name: "Technology", budget: 100213, spend: 100213 },
  { name: "Healthcare", budget: 98073, spend: 98073 },
  { name: "Retail", budget: 108064, spend: 108064 },
  { name: "Finance", budget: 111096, spend: 111096 },
  { name: "Manufacturing", budget: 108675, spend: 108675 },
  { name: "Technology", budget: 100213, spend: 100213 },
  { name: "Healthcare", budget: 98073, spend: 98073 },
  { name: "Retail", budget: 108064, spend: 108064 },
  { name: "Finance", budget: 111096, spend: 111096 },
  { name: "Manufacturing", budget: 108675, spend: 108675 },
  { name: "Technology", budget: 100213, spend: 100213 },
  { name: "Healthcare", budget: 98073, spend: 98073 },
  { name: "Retail", budget: 108064, spend: 108064 },
  { name: "Finance", budget: 111096, spend: 111096 },
  { name: "Manufacturing", budget: 108675, spend: 108675 },
  { name: "Technology", budget: 100213, spend: 100213 },
  { name: "Healthcare", budget: 98073, spend: 98073 },
  { name: "Retail", budget: 108064, spend: 108064 },
  { name: "Finance", budget: 111096, spend: 111096 },
  { name: "Manufacturing", budget: 108675, spend: 108675 },
  { name: "Technology", budget: 100213, spend: 100213 },
  { name: "Healthcare", budget: 98073, spend: 98073 },
  { name: "Retail", budget: 108064, spend: 108064 },
  { name: "Finance", budget: 111096, spend: 111096 },
  { name: "Manufacturing", budget: 108675, spend: 108675 },
];

const supplierData = {
  Technology: [
    { name: "Global Tech", budget: 100213, spend: 100213 },
    { name: "SR Legals", budget: 98073, spend: 98073 },
    { name: "Ecotech", budget: 108064, spend: 108064 },
    { name: "Next Gen Care", budget: 111096, spend: 111096 },
    { name: "First Student LLC", budget: 108675, spend: 108675 },
  ],
};

const chartDataTemplate = (data) => ({
  labels: data.map((item) => item.industry),
  datasets: [
    {
      data: data.map((item) => item.data),
      backgroundColor: colors.slice(0, data.length),
      borderWidth: 0,
    },
  ],
});

const SpendCard = ({
  title,
  subtitle,
  amount,
  data,
  setIsOpen,
  setView,
  industries,
  suppliers,
}) => {
  return (
    <div className="bg-white border shadow-md rounded-2xl p-6 w-full max-w-sm sm:max-w-md md:max-w-lg lg:max-w-xl xl:max-w-2xl h-auto flex flex-col items-center">
      <div className="w-full flex flex-col items-start mb-4">
        <div className="flex flex-row justify-between items-center w-full">
          <div className="flex flex-row items-center gap-2 mb-1">
            <div className="bg-[#F6F6F6] rounded-xl p-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
              >
                <path
                  d="M13.9993 10.667C13.4741 10.667 12.9539 10.7705 12.4686 10.9715C11.9833 11.1725 11.5424 11.4671 11.1709 11.8386C10.7995 12.21 10.5048 12.651 10.3038 13.1363C10.1028 13.6216 9.99935 14.1417 9.99935 14.667C9.99935 15.1923 10.1028 15.7124 10.3038 16.1977C10.5048 16.683 10.7995 17.124 11.1709 17.4954C11.5424 17.8669 11.9833 18.1615 12.4686 18.3625C12.9539 18.5635 13.4741 18.667 13.9993 18.667C15.0602 18.667 16.0776 18.2456 16.8278 17.4954C17.5779 16.7453 17.9993 15.7279 17.9993 14.667C17.9993 13.6061 17.5779 12.5887 16.8278 11.8386C16.0776 11.0884 15.0602 10.667 13.9993 10.667ZM11.9993 14.667C11.9993 14.1366 12.2101 13.6279 12.5851 13.2528C12.9602 12.8777 13.4689 12.667 13.9993 12.667C14.5298 12.667 15.0385 12.8777 15.4136 13.2528C15.7886 13.6279 15.9993 14.1366 15.9993 14.667C15.9993 15.1974 15.7886 15.7061 15.4136 16.0812C15.0385 16.4563 14.5298 16.667 13.9993 16.667C13.4689 16.667 12.9602 16.4563 12.5851 16.0812C12.2101 15.7061 11.9993 15.1974 11.9993 14.667ZM2.66602 9.66699C2.66602 8.87134 2.98209 8.10828 3.5447 7.54567C4.1073 6.98306 4.87037 6.66699 5.66602 6.66699H22.3327C22.7266 6.66699 23.1168 6.74459 23.4807 6.89535C23.8447 7.04612 24.1754 7.2671 24.454 7.54567C24.7326 7.82425 24.9536 8.15497 25.1043 8.51894C25.2551 8.88292 25.3327 9.27303 25.3327 9.66699V19.667C25.3327 20.061 25.2551 20.4511 25.1043 20.815C24.9536 21.179 24.7326 21.5097 24.454 21.7883C24.1754 22.0669 23.8447 22.2879 23.4807 22.4386C23.1168 22.5894 22.7266 22.667 22.3327 22.667H5.66602C4.87037 22.667 4.1073 22.3509 3.5447 21.7883C2.98209 21.2257 2.66602 20.4626 2.66602 19.667V9.66699ZM5.66602 8.66699C5.4008 8.66699 5.14645 8.77235 4.95891 8.95989C4.77137 9.14742 4.66602 9.40178 4.66602 9.66699V10.667H5.66602C5.93123 10.667 6.18559 10.5616 6.37312 10.3741C6.56066 10.1866 6.66602 9.93221 6.66602 9.66699V8.66699H5.66602ZM4.66602 16.667H5.66602C6.46166 16.667 7.22473 16.9831 7.78734 17.5457C8.34994 18.1083 8.66602 18.8713 8.66602 19.667V20.667H19.3327V19.667C19.3327 18.8713 19.6488 18.1083 20.2114 17.5457C20.774 16.9831 21.537 16.667 22.3327 16.667H23.3327V12.667H22.3327C21.537 12.667 20.774 12.3509 20.2114 11.7883C19.6488 11.2257 19.3327 10.4626 19.3327 9.66699V8.66699H8.66602V9.66699C8.66602 10.061 8.58842 10.4511 8.43765 10.815C8.28689 11.179 8.06591 11.5097 7.78734 11.7883C7.50876 12.0669 7.17804 12.2879 6.81407 12.4386C6.45009 12.5894 6.05998 12.667 5.66602 12.667H4.66602V16.667ZM23.3327 10.667V9.66699C23.3327 9.40178 23.2273 9.14742 23.0398 8.95989C22.8523 8.77235 22.5979 8.66699 22.3327 8.66699H21.3327V9.66699C21.3327 10.219 21.7807 10.667 22.3327 10.667H23.3327ZM23.3327 18.667H22.3327C22.0675 18.667 21.8131 18.7724 21.6256 18.9599C21.438 19.1474 21.3327 19.4018 21.3327 19.667V20.667H22.3327C22.5979 20.667 22.8523 20.5616 23.0398 20.3741C23.2273 20.1866 23.3327 19.9322 23.3327 19.667V18.667ZM4.66602 19.667C4.66602 20.219 5.11402 20.667 5.66602 20.667H6.66602V19.667C6.66602 19.4018 6.56066 19.1474 6.37312 18.9599C6.18559 18.7724 5.93123 18.667 5.66602 18.667H4.66602V19.667ZM5.86735 24.667C6.21842 25.2753 6.72355 25.7805 7.33188 26.1316C7.94022 26.4827 8.6303 26.6673 9.33268 26.667H22.9993C23.8311 26.667 24.6546 26.5032 25.423 26.1849C26.1914 25.8666 26.8896 25.4001 27.4777 24.812C28.0658 24.2239 28.5323 23.5257 28.8506 22.7573C29.1689 21.9889 29.3327 21.1654 29.3327 20.3337V13.3337C29.3329 12.6313 29.1482 11.9413 28.7971 11.333C28.446 10.7246 27.9409 10.2195 27.3327 9.86833V20.3337C27.3327 21.4829 26.8761 22.5851 26.0635 23.3978C25.2508 24.2104 24.1486 24.667 22.9993 24.667H5.86735Z"
                  fill="#656565"
                />
              </svg>
            </div>
            <div className="flex flex-col justify-start items-start">
              <div className="flex flex-row gap-2">
                {title}{" "}
                <span className="text-gray-400">
                  {title === "Highest Spend" ? "(Supplier)" : "(Industry)"}
                </span>
              </div>

              {subtitle && <p className="text-sm text-gray-500">{subtitle}</p>}
            </div>
          </div>
           {title !== "Highest Spend" && 
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="19"
            height="19"
            viewBox="0 0 19 19"
            fill="none"
            className="flex"
            onClick={() => {
              setIsOpen(true);
              setView("industry");
            }}
          >
            <path
              d="M0.332031 18.5V13.5H2.33203V16.5H5.33203V18.5H0.332031ZM13.332 18.5V16.5H16.332V13.5H18.332V18.5H13.332ZM0.332031 5.5V0.5H5.33203V2.5H2.33203V5.5H0.332031ZM16.332 5.5V2.5H13.332V0.5H18.332V5.5H16.332Z"
              fill="black"
            />
          </svg>
}
        </div>

        <h3 className="text-3xl font-bold text-gray-900 mt-6 mb-6">
          ${amount?.toLocaleString()}
        </h3>
      </div>
      <div className="w-full max-w-[400px] aspect-square mx-auto pb-6">
        <Doughnut data={chartDataTemplate(data)} options={chartOptions} />
      </div>

      <div className="flex flex-wrap justify-center mt-4 gap-2 text-sm">
        {(title === "Highest Spend" ? suppliers : industries)?.map(
          (name, i) => (
            <span key={i} className="flex items-center gap-1 text-gray-600">
              <span
                className="w-3 h-3 rounded-full"
                style={{ backgroundColor: colors[i] }}
              ></span>
              {name}
            </span>
          )
        )}
      </div>
    </div>
  );
};
const SpendTracker = ({ activeTab }) => {
  const [dialogActiveTab, setDialogActiveTab] = useState("Monthly");
  const tabs = ["Monthly", "Last 3 Months", "Yearly"];
  const [isOpen, setIsOpen] = useState(false);
  const [view, setView] = useState("industry");
  const [selectedIndustry, setSelectedIndustry] = useState(null);
  const dispatch = useDispatch();
  const {
    lastThree,
    current,
    yearly,
    lastThreeMetrics,
    currentMetrics,
    yearlyMetrics,
  } = useSelector((state) => state.metrics);



  const buyerId = useSelector((state) => state.auth.id);
  const [industries, setIndustries] = useState([]);
  const [suppliers, setSuppliers] = useState([]);

  const [dataByTab, setDataByTab] = useState({
    Monthly: [],
    "Last 3 Months": [],
    Yearly: [],
  });

//   const [industryData, setIndustryData] = useState([]);

// useEffect(() => {
//   const data =
//     dialogActiveTab === "Monthly"
//       ? current?.data ?? []
//       : dialogActiveTab === "Last 3 Months"
//       ? lastThree?.data ?? []
//       : yearly?.data ?? [];

//   setIndustryData(data);
// }, [dialogActiveTab, current, lastThree, yearly]);

  const formatSortedBudget = (sortedBudget) => {
    if (!sortedBudget) return [];
    const formatted = sortedBudget.map((item) => ({
      industry: item.industry,
      data: item.budget,
    }));

    setIndustries(sortedBudget.map((item) => item.industry));
    return formatted;
  };

  const formatSortedSpend = (sortedSpend) => {
    if (!sortedSpend) return [];

    const formatted = sortedSpend.map((item) => ({
      industry: item.industry,
      data: item.amount,
    }));

    setIndustries(sortedSpend.map((item) => item.industry));
    return formatted;
  };

  const formatHighestSpend = (sortedSpend) => {
    if (!sortedSpend) return [];

    const formatted = sortedSpend.map((item) => ({
      supplierName: item.supplierName,
      data: item.amount,
    }));

    setSuppliers(sortedSpend.map((item) => item.supplierName));
    return formatted;
  };

  useEffect(() => {
    setDataByTab({
      Monthly: [
        {
          title: "Total Budget",
          subtitle: currentMetrics?.summary?.endMonth,
          amount: currentMetrics?.summary?.totalBudget,
          data: formatSortedBudget(current?.data?.sortedBudget),
        },
        {
          title: "Total Spend",
          subtitle: currentMetrics?.summary?.endMonth,
          amount: currentMetrics?.summary?.totalAmount,
          data: formatSortedSpend(current?.data?.sortedSpend),
        },
        {
          title: "Highest Spend",
          subtitle: currentMetrics?.summary?.endMonth,
          amount: currentMetrics?.highestSpend?.[0]?.amount ?? 0,
          data: formatHighestSpend(currentMetrics?.highestSpend),
        },
      ],
      "Last 3 Months": [
        {
          title: "Total Budget",
          subtitle: lastThreeMetrics?.summary
            ? lastThreeMetrics.summary.startMonth ===
              lastThreeMetrics.summary.endMonth
              ? `${lastThreeMetrics.summary.startMonth} ${lastThreeMetrics.summary.currentYear}`
              : `${lastThreeMetrics.summary.startMonth}–${lastThreeMetrics.summary.endMonth} ${lastThreeMetrics.summary.currentYear}`
            : "",
          amount: lastThreeMetrics?.summary?.totalBudget,
          data: formatSortedBudget(lastThree?.data?.sortedBudget),
        },
        {
          title: "Total Spend",
          subtitle: lastThreeMetrics?.summary
            ? lastThreeMetrics.summary.startMonth ===
              lastThreeMetrics.summary.endMonth
              ? `${lastThreeMetrics.summary.startMonth} ${lastThreeMetrics.summary.currentYear}`
              : `${lastThreeMetrics.summary.startMonth}–${lastThreeMetrics.summary.endMonth} ${lastThreeMetrics.summary.currentYear}`
            : "",
          amount: lastThreeMetrics?.summary?.totalAmount,
          data: formatSortedSpend(lastThree?.data?.sortedSpend),
        },
        {
          title: "Highest Spend",
          subtitle: lastThreeMetrics?.summary
            ? lastThreeMetrics.summary.startMonth ===
              lastThreeMetrics.summary.endMonth
              ? `${lastThreeMetrics.summary.startMonth} ${lastThreeMetrics.summary.currentYear}`
              : `${lastThreeMetrics.summary.startMonth}–${lastThreeMetrics.summary.endMonth} ${lastThreeMetrics.summary.currentYear}`
            : "",
          amount: lastThreeMetrics?.highestSpend?.[0]?.amount ?? 0,
          data: formatHighestSpend(lastThreeMetrics?.highestSpend),
        },
      ],
      Yearly: [
        {
          title: "Total Budget",
          subtitle: yearlyMetrics?.summary?.currentYear,
          amount: yearlyMetrics?.summary?.totalBudget,
          data: formatSortedBudget(yearly?.data?.sortedBudget),
        },
        {
          title: "Total Spend",
          subtitle: yearlyMetrics?.summary?.currentYear,
          amount: yearlyMetrics?.summary?.totalAmount,
          data: formatSortedSpend(yearly?.data?.sortedSpend),
        },
        {
          title: "Highest Spend",
          subtitle: yearlyMetrics?.summary?.currentYear,
          amount: yearlyMetrics?.highestSpend?.[0]?.amount ?? 0,
          data: formatHighestSpend(yearlyMetrics?.highestSpend),
        },
      ],
    });
  }, [
    current,
    lastThree,
    yearly,
    currentMetrics,
    lastThreeMetrics,
    yearlyMetrics,
  ]);
  console.log(industryData, 'industry data')
  useEffect(() => {
    if (!buyerId) return;

    switch (activeTab) {
      case "Monthly":
        dispatch(fetchCurrentIndustries(buyerId));
        dispatch(fetchCurrentMetrics(buyerId));
        break;

      case "Last 3 Months":
        dispatch(fetchLastThreeIndustries(buyerId));
        dispatch(fetchLastThreeMetrics(buyerId));
        break;

      case "Yearly":
        dispatch(fetchYearlyIndustries(buyerId));
        dispatch(fetchYearlyMetrics(buyerId));
        break;

      default:
        dispatch(fetchCurrentIndustries(buyerId));
        dispatch(fetchCurrentMetrics(buyerId));
    }
  }, [activeTab, buyerId, dispatch]);

  return (
    <div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {dataByTab[activeTab]?.map(({ title, subtitle, amount, data }, idx) => (
          <SpendCard
            key={idx}
            title={title}
            subtitle={subtitle}
            amount={amount}
            data={data}
            setIsOpen={setIsOpen}
            setView={setView}
            industries={industries}
            suppliers={suppliers}
          />
        ))}

        <Dialog
          open={isOpen}
          onClose={() => setIsOpen(false)}
          className="relative"
          style={{ zIndex: 10000 }}
        >
          <div className="fixed inset-0 bg-black/40" aria-hidden="true" />
          <div className="fixed inset-0 flex items-center justify-center p-4">
            <Dialog.Panel className="w-full max-w-3xl rounded-lg bg-white p-6 shadow-lg">
              {/* Wrap scrollable content here */}
              <div className="max-h-[75vh] overflow-y-auto pr-2">
                {/* Header + Industry View */}
                {view === "industry" && (
                  <>
                    <div className="flex justify-between items-center mb-6 mt-6">
                      <h2 className="text-base text-[#1D2739] font-semibold">
                        Total Budget and Spend{" "}
                        <span className="text-[#9B9B9B] font-normal">
                          (Industry)
                        </span>
                      </h2>

                      <div className="flex flex-row items-center gap-4">
                        <div className="flex gap-2 bg-white rounded-xl p-1 shadow">
                          {tabs.map((tab, i) => (
                            <button
                              key={tab}
                              onClick={() => setDialogActiveTab(tab)}
                              className={`
                px-2 py-1 border-r last:border-r-0
                ${
                  dialogActiveTab === tab
                    ? "text-[#08F] font-semibold"
                    : "text-gray-600 hover:text-gray-400"
                }
              `}
                            >
                              {tab}
                            </button>
                          ))}
                        </div>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="17"
                          viewBox="0 0 16 17"
                          fill="none"
                        >
                          <path
                            d="M8 12.5L3 7.5L4.4 6.05L7 8.65V0.5H9V8.65L11.6 6.05L13 7.5L8 12.5ZM2 16.5C1.45 16.5 0.979167 16.3042 0.5875 15.9125C0.195833 15.5208 0 15.05 0 14.5V11.5H2V14.5H14V11.5H16V14.5C16 15.05 15.8042 15.5208 15.4125 15.9125C15.0208 16.3042 14.55 16.5 14 16.5H2Z"
                            fill="black"
                          />
                        </svg>
                        <button
                          onClick={() => setIsOpen(false)}
                          className="text-gray-500 bg-[#EDEDED] rounded py-1 px-2"
                        >
                          Close
                        </button>
                      </div>
                    </div>

                    <table className="w-full border-collapse">
                      <thead className="bg-gray-100">
                        <tr className="text-left border-b">
                          <th className="py-2">Industry</th>
                          <th>Budget</th>
                          <th>Spend</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {industryData?.map((ind, i) => (
                          <tr key={i} className="border-b">
                            <td className="py-2">{ind.name}</td>
                            <td>${ind.budget.toLocaleString()}</td>
                            <td>${ind.spend.toLocaleString()}</td>
                            <td>
                              <button
                                className="px-3 py-1 bg-blue-100 text-[#08F] rounded"
                                onClick={() => {
                                  setSelectedIndustry(ind.name);
                                  setView("suppliers");
                                }}
                              >
                                View Suppliers
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </>
                )}

                {/* Suppliers View */}
                {view === "suppliers" && (
                  <>
                    <div className="flex flex-col items-left mb-4">
                      <button
                        onClick={() => setView("industry")}
                        className="text-[#7B7B7B] text-sm mr-3 mb-6 mt-4 text-left"
                      >
                        ← Go back
                      </button>
                      <div className="flex justify-between items-center mb-4">
                        <h2 className="text-base text-[#757575]">
                          {selectedIndustry} Industry ›{" "}
                          <span className="font-semibold text-[#1D2739] text-base">
                            Suppliers
                          </span>
                        </h2>

                        <div className="flex flex-row items-center gap-4">
                          <div className="flex gap-2 bg-white rounded-xl p-1 shadow">
                            {tabs.map((tab, i) => (
                              <button
                                key={tab}
                                onClick={() => setDialogActiveTab(tab)}
                                className={`
                px-2 py-1 border-r last:border-r-0
                ${
                  dialogActiveTab === tab
                    ? "text-[#08F] font-semibold"
                    : "text-gray-600 hover:text-gray-400"
                }
              `}
                              >
                                {tab}
                              </button>
                            ))}
                          </div>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="17"
                            viewBox="0 0 16 17"
                            fill="none"
                          >
                            <path
                              d="M8 12.5L3 7.5L4.4 6.05L7 8.65V0.5H9V8.65L11.6 6.05L13 7.5L8 12.5ZM2 16.5C1.45 16.5 0.979167 16.3042 0.5875 15.9125C0.195833 15.5208 0 15.05 0 14.5V11.5H2V14.5H14V11.5H16V14.5C16 15.05 15.8042 15.5208 15.4125 15.9125C15.0208 16.3042 14.55 16.5 14 16.5H2Z"
                              fill="black"
                            />
                          </svg>
                          <button
                            onClick={() => setIsOpen(false)}
                            className="text-gray-500 bg-[#EDEDED] rounded py-1 px-2"
                          >
                            Close
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="flex flex-row justify-start gap-4 mb-4">
                      <div className="p-6 rounded-2xl border flex flex-row justify-start items-center gap-4 w-[226px]">
                        <div className="bg-[#F6F6F6] p-2 rounded">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="32"
                            height="32"
                            viewBox="0 0 32 32"
                            fill="none"
                          >
                            <path
                              d="M13.9974 10.668C13.4721 10.668 12.952 10.7714 12.4667 10.9725C11.9814 11.1735 11.5404 11.4681 11.169 11.8395C10.7975 12.211 10.5029 12.6519 10.3019 13.1372C10.1009 13.6225 9.9974 14.1427 9.9974 14.668C9.9974 15.1933 10.1009 15.7134 10.3019 16.1987C10.5029 16.684 10.7975 17.125 11.169 17.4964C11.5404 17.8678 11.9814 18.1625 12.4667 18.3635C12.952 18.5645 13.4721 18.668 13.9974 18.668C15.0583 18.668 16.0757 18.2465 16.8258 17.4964C17.576 16.7463 17.9974 15.7288 17.9974 14.668C17.9974 13.6071 17.576 12.5897 16.8258 11.8395C16.0757 11.0894 15.0583 10.668 13.9974 10.668ZM11.9974 14.668C11.9974 14.1375 12.2081 13.6288 12.5832 13.2538C12.9583 12.8787 13.467 12.668 13.9974 12.668C14.5278 12.668 15.0365 12.8787 15.4116 13.2538C15.7867 13.6288 15.9974 14.1375 15.9974 14.668C15.9974 15.1984 15.7867 15.7071 15.4116 16.0822C15.0365 16.4573 14.5278 16.668 13.9974 16.668C13.467 16.668 12.9583 16.4573 12.5832 16.0822C12.2081 15.7071 11.9974 15.1984 11.9974 14.668ZM2.66406 9.66797C2.66406 8.87232 2.98013 8.10926 3.54274 7.54665C4.10535 6.98404 4.86841 6.66797 5.66406 6.66797H22.3307C22.7247 6.66797 23.1148 6.74557 23.4788 6.89633C23.8428 7.04709 24.1735 7.26807 24.452 7.54665C24.7306 7.82522 24.9516 8.15594 25.1024 8.51992C25.2531 8.8839 25.3307 9.274 25.3307 9.66797V19.668C25.3307 20.0619 25.2531 20.452 25.1024 20.816C24.9516 21.18 24.7306 21.5107 24.452 21.7893C24.1735 22.0679 23.8428 22.2888 23.4788 22.4396C23.1148 22.5904 22.7247 22.668 22.3307 22.668H5.66406C4.86841 22.668 4.10535 22.3519 3.54274 21.7893C2.98013 21.2267 2.66406 20.4636 2.66406 19.668V9.66797ZM5.66406 8.66797C5.39885 8.66797 5.14449 8.77333 4.95696 8.96086C4.76942 9.1484 4.66406 9.40275 4.66406 9.66797V10.668H5.66406C5.92928 10.668 6.18363 10.5626 6.37117 10.3751C6.55871 10.1875 6.66406 9.93319 6.66406 9.66797V8.66797H5.66406ZM4.66406 16.668H5.66406C6.45971 16.668 7.22277 16.984 7.78538 17.5466C8.34799 18.1093 8.66406 18.8723 8.66406 19.668V20.668H19.3307V19.668C19.3307 18.8723 19.6468 18.1093 20.2094 17.5466C20.772 16.984 21.5351 16.668 22.3307 16.668H23.3307V12.668H22.3307C21.5351 12.668 20.772 12.3519 20.2094 11.7893C19.6468 11.2267 19.3307 10.4636 19.3307 9.66797V8.66797H8.66406V9.66797C8.66406 10.0619 8.58647 10.452 8.4357 10.816C8.28494 11.18 8.06396 11.5107 7.78538 11.7893C7.50681 12.0679 7.17609 12.2888 6.81211 12.4396C6.44814 12.5904 6.05803 12.668 5.66406 12.668H4.66406V16.668ZM23.3307 10.668V9.66797C23.3307 9.40275 23.2254 9.1484 23.0378 8.96086C22.8503 8.77333 22.5959 8.66797 22.3307 8.66797H21.3307V9.66797C21.3307 10.22 21.7787 10.668 22.3307 10.668H23.3307ZM23.3307 18.668H22.3307C22.0655 18.668 21.8112 18.7733 21.6236 18.9609C21.4361 19.1484 21.3307 19.4028 21.3307 19.668V20.668H22.3307C22.5959 20.668 22.8503 20.5626 23.0378 20.3751C23.2254 20.1875 23.3307 19.9332 23.3307 19.668V18.668ZM4.66406 19.668C4.66406 20.22 5.11206 20.668 5.66406 20.668H6.66406V19.668C6.66406 19.4028 6.55871 19.1484 6.37117 18.9609C6.18363 18.7733 5.92928 18.668 5.66406 18.668H4.66406V19.668ZM5.8654 24.668C6.21647 25.2763 6.72159 25.7815 7.32993 26.1326C7.93826 26.4837 8.62835 26.6683 9.33073 26.668H22.9974C23.8291 26.668 24.6527 26.5042 25.4211 26.1859C26.1895 25.8676 26.8876 25.4011 27.4757 24.813C28.0638 24.2249 28.5304 23.5267 28.8486 22.7583C29.1669 21.9899 29.3307 21.1663 29.3307 20.3346V13.3346C29.3309 12.6323 29.1462 11.9422 28.7951 11.3339C28.4441 10.7256 27.939 10.2205 27.3307 9.8693V20.3346C27.3307 21.4839 26.8742 22.5861 26.0615 23.3988C25.2489 24.2114 24.1467 24.668 22.9974 24.668H5.8654Z"
                              fill="#656565"
                            />
                          </svg>
                        </div>
                        <div className="flex flex-col">
                          <p className="text-sm text-[#666]">Total Budget</p>
                          <p className="text-xl font-semibold text-[#1D2739]">
                            $
                            {supplierData[selectedIndustry]
                              ?.reduce((acc, s) => acc + s.budget, 0)
                              .toLocaleString()}
                          </p>
                        </div>
                      </div>
                      <div className="p-6 rounded-2xl border flex flex-row justify-start items-center gap-4 w-[226px]">
                        <div className="bg-[#F6F6F6] p-2 rounded">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="32"
                            height="32"
                            viewBox="0 0 32 32"
                            fill="none"
                          >
                            <path
                              d="M13.9974 10.668C13.4721 10.668 12.952 10.7714 12.4667 10.9725C11.9814 11.1735 11.5404 11.4681 11.169 11.8395C10.7975 12.211 10.5029 12.6519 10.3019 13.1372C10.1009 13.6225 9.9974 14.1427 9.9974 14.668C9.9974 15.1933 10.1009 15.7134 10.3019 16.1987C10.5029 16.684 10.7975 17.125 11.169 17.4964C11.5404 17.8678 11.9814 18.1625 12.4667 18.3635C12.952 18.5645 13.4721 18.668 13.9974 18.668C15.0583 18.668 16.0757 18.2465 16.8258 17.4964C17.576 16.7463 17.9974 15.7288 17.9974 14.668C17.9974 13.6071 17.576 12.5897 16.8258 11.8395C16.0757 11.0894 15.0583 10.668 13.9974 10.668ZM11.9974 14.668C11.9974 14.1375 12.2081 13.6288 12.5832 13.2538C12.9583 12.8787 13.467 12.668 13.9974 12.668C14.5278 12.668 15.0365 12.8787 15.4116 13.2538C15.7867 13.6288 15.9974 14.1375 15.9974 14.668C15.9974 15.1984 15.7867 15.7071 15.4116 16.0822C15.0365 16.4573 14.5278 16.668 13.9974 16.668C13.467 16.668 12.9583 16.4573 12.5832 16.0822C12.2081 15.7071 11.9974 15.1984 11.9974 14.668ZM2.66406 9.66797C2.66406 8.87232 2.98013 8.10926 3.54274 7.54665C4.10535 6.98404 4.86841 6.66797 5.66406 6.66797H22.3307C22.7247 6.66797 23.1148 6.74557 23.4788 6.89633C23.8428 7.04709 24.1735 7.26807 24.452 7.54665C24.7306 7.82522 24.9516 8.15594 25.1024 8.51992C25.2531 8.8839 25.3307 9.274 25.3307 9.66797V19.668C25.3307 20.0619 25.2531 20.452 25.1024 20.816C24.9516 21.18 24.7306 21.5107 24.452 21.7893C24.1735 22.0679 23.8428 22.2888 23.4788 22.4396C23.1148 22.5904 22.7247 22.668 22.3307 22.668H5.66406C4.86841 22.668 4.10535 22.3519 3.54274 21.7893C2.98013 21.2267 2.66406 20.4636 2.66406 19.668V9.66797ZM5.66406 8.66797C5.39885 8.66797 5.14449 8.77333 4.95696 8.96086C4.76942 9.1484 4.66406 9.40275 4.66406 9.66797V10.668H5.66406C5.92928 10.668 6.18363 10.5626 6.37117 10.3751C6.55871 10.1875 6.66406 9.93319 6.66406 9.66797V8.66797H5.66406ZM4.66406 16.668H5.66406C6.45971 16.668 7.22277 16.984 7.78538 17.5466C8.34799 18.1093 8.66406 18.8723 8.66406 19.668V20.668H19.3307V19.668C19.3307 18.8723 19.6468 18.1093 20.2094 17.5466C20.772 16.984 21.5351 16.668 22.3307 16.668H23.3307V12.668H22.3307C21.5351 12.668 20.772 12.3519 20.2094 11.7893C19.6468 11.2267 19.3307 10.4636 19.3307 9.66797V8.66797H8.66406V9.66797C8.66406 10.0619 8.58647 10.452 8.4357 10.816C8.28494 11.18 8.06396 11.5107 7.78538 11.7893C7.50681 12.0679 7.17609 12.2888 6.81211 12.4396C6.44814 12.5904 6.05803 12.668 5.66406 12.668H4.66406V16.668ZM23.3307 10.668V9.66797C23.3307 9.40275 23.2254 9.1484 23.0378 8.96086C22.8503 8.77333 22.5959 8.66797 22.3307 8.66797H21.3307V9.66797C21.3307 10.22 21.7787 10.668 22.3307 10.668H23.3307ZM23.3307 18.668H22.3307C22.0655 18.668 21.8112 18.7733 21.6236 18.9609C21.4361 19.1484 21.3307 19.4028 21.3307 19.668V20.668H22.3307C22.5959 20.668 22.8503 20.5626 23.0378 20.3751C23.2254 20.1875 23.3307 19.9332 23.3307 19.668V18.668ZM4.66406 19.668C4.66406 20.22 5.11206 20.668 5.66406 20.668H6.66406V19.668C6.66406 19.4028 6.55871 19.1484 6.37117 18.9609C6.18363 18.7733 5.92928 18.668 5.66406 18.668H4.66406V19.668ZM5.8654 24.668C6.21647 25.2763 6.72159 25.7815 7.32993 26.1326C7.93826 26.4837 8.62835 26.6683 9.33073 26.668H22.9974C23.8291 26.668 24.6527 26.5042 25.4211 26.1859C26.1895 25.8676 26.8876 25.4011 27.4757 24.813C28.0638 24.2249 28.5304 23.5267 28.8486 22.7583C29.1669 21.9899 29.3307 21.1663 29.3307 20.3346V13.3346C29.3309 12.6323 29.1462 11.9422 28.7951 11.3339C28.4441 10.7256 27.939 10.2205 27.3307 9.8693V20.3346C27.3307 21.4839 26.8742 22.5861 26.0615 23.3988C25.2489 24.2114 24.1467 24.668 22.9974 24.668H5.8654Z"
                              fill="#656565"
                            />
                          </svg>
                        </div>

                        <div className="flex flex-col">
                          <p className="text-sm text-gray-500">Total Spend</p>
                          <p className="text-xl font-bold">
                            $
                            {supplierData[selectedIndustry]
                              ?.reduce((acc, s) => acc + s.spend, 0)
                              .toLocaleString()}
                          </p>
                        </div>
                      </div>
                    </div>

                    <table className="w-full border-collapse">
                      <thead className="bg-gray-100">
                        <tr className="text-left border-b">
                          <th className="py-2">Supplier</th>
                          <th>Budget</th>
                          <th>Spend</th>
                        </tr>
                      </thead>
                      <tbody>
                        {supplierData[selectedIndustry]?.map((s, i) => (
                          <tr key={i} className="border-b">
                            <td className="py-2">{s.name}</td>
                            <td>${s.budget.toLocaleString()}</td>
                            <td>${s.spend.toLocaleString()}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </>
                )}
              </div>
            </Dialog.Panel>
          </div>
        </Dialog>
      </div>
    </div>
  );
};

export default SpendTracker;
